import { Reducer, useEffect, useReducer } from "react"
import { Book, StatusEnum } from "../book/data-types"
import { changeBookStatus } from "../book/change-status"

type ChangeStatusState = {
    pending: boolean
    book: Book | null
    error?: string
}

export type ChangeStatusFunction = (status_id: StatusEnum, token?: string, force?: boolean) => Promise<number | undefined>

export const useChangeStatus = (b: Book | null): [ChangeStatusState, ChangeStatusFunction] => {
    const [state, setState] = useReducer<Reducer<ChangeStatusState, Partial<ChangeStatusState>>>(
        (state, newState) => ({...state, ...newState}),
        {
            pending: false, 
            book: b,
        }
    )

    useEffect(() => {
        setState({ ...state, book: b })
    }, [b])

    if (b == null) {
        return [state, async () => undefined]
    }
    
    const changeStatus = async (status_id: StatusEnum, token?: string, force?: boolean) => {
        if (!token) {
            return
        }

        setState({ pending: true })

        const isbn_db = b.isbn_db || false
        const isbn13 = b.isbn13

        const { book, error }= await changeBookStatus(isbn13, status_id, isbn_db, token, force)
        if (error) {
            setState({ error, pending: false })
            return
        }

        setState({ book, error: undefined, pending: false })
        return book?.club_id
    }

    return [state, changeStatus]
}